import Vue from "vue"
import VueRouter from "vue-router"
import setDocuemntTtitle from "@/utils/setDocumentTitle"
import store from "@/store"

// const home = () => import("../views/Home/index")
const homePage = () => import("../views/HomePage/index")
const shopDetails = () => import("../views/shopDetails/index")
const nothingnessActivity = () => import("../views/NothingnessActivity/index")

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: "/",
    name: "homePage",
    meta: {
      title: "",
      keepAlive: false
    },
    component: homePage
  },
  {
    path: "/shopDetails",
    name: "shopDetails",
    meta: {
      title: "",
      keepAlive: false
    },
    component: shopDetails
  },
  {
    path: "/nothingnessActivity",
    name: "nothingnessActivity",
    meta: { title: " " },
    component: nothingnessActivity
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  const activityTitle = store.state.activityInfo.activityDetail.activityName
  const title = to.meta.title ? to.meta.title : activityTitle ? activityTitle : ""
  if (title) {
    setDocuemntTtitle(title)
  }
  next()
})

export default router
